{
  "formatVersion": 1,
  "name": "blackline-monteforte",
  "displayName": "Monteforte",
  "description": "A hillside Italian village at midday: attackers start on a gravel road in the south-east, defenders in a yard behind the church in the north-west. A chain of walled terraces climbs the east side to the walled courtyard at B, and an alley from the road opens into a small plaza that splits between a house with a roof deck over A and a vaulted passage down into A — the church plaza, with a sunken pit and a graveyard of low brick tombs.",
  "visual": null,
  "environment": "day",
  "brushes": [
    {
      "kind": "box",
      "center": [
        -42.5,
        -0.5,
        0
      ],
      "halfExtents": [
        2.5,
        0.5,
        40
      ],
      "material": "concrete",
      "note": "street floor west"
    },
    {
      "kind": "box",
      "center": [
        5.5,
        -0.5,
        0
      ],
      "halfExtents": [
        39.5,
        0.5,
        40
      ],
      "material": "concrete",
      "note": "street floor east"
    },
    {
      "kind": "box",
      "center": [
        -37,
        -0.5,
        -17
      ],
      "halfExtents": [
        3,
        0.5,
        23
      ],
      "material": "concrete",
      "note": "street floor north"
    },
    {
      "kind": "box",
      "center": [
        -37,
        -0.5,
        26
      ],
      "halfExtents": [
        3,
        0.5,
        14
      ],
      "material": "concrete",
      "note": "street floor south"
    },
    {
      "kind": "box",
      "center": [
        -37,
        -1.25,
        9
      ],
      "halfExtents": [
        3,
        0.25,
        3
      ],
      "material": "gravel",
      "note": "pit floor"
    },
    {
      "kind": "box",
      "center": [
        -35.488,
        -0.925,
        9
      ],
      "halfExtents": [
        0.113,
        0.075,
        1
      ],
      "material": "tile",
      "note": "pit stair step 1"
    },
    {
      "kind": "box",
      "center": [
        -35.262,
        -0.85,
        9
      ],
      "halfExtents": [
        0.113,
        0.15,
        1
      ],
      "material": "tile",
      "note": "pit stair step 2"
    },
    {
      "kind": "box",
      "center": [
        -35.037,
        -0.775,
        9
      ],
      "halfExtents": [
        0.113,
        0.225,
        1
      ],
      "material": "tile",
      "note": "pit stair step 3"
    },
    {
      "kind": "box",
      "center": [
        -34.812,
        -0.7,
        9
      ],
      "halfExtents": [
        0.113,
        0.3,
        1
      ],
      "material": "tile",
      "note": "pit stair step 4"
    },
    {
      "kind": "box",
      "center": [
        -34.587,
        -0.625,
        9
      ],
      "halfExtents": [
        0.113,
        0.375,
        1
      ],
      "material": "tile",
      "note": "pit stair step 5"
    },
    {
      "kind": "box",
      "center": [
        -34.363,
        -0.55,
        9
      ],
      "halfExtents": [
        0.113,
        0.45,
        1
      ],
      "material": "tile",
      "note": "pit stair step 6"
    },
    {
      "kind": "box",
      "center": [
        -34.137,
        -0.51,
        9
      ],
      "halfExtents": [
        0.113,
        0.49,
        1
      ],
      "material": "tile",
      "note": "pit stair step 7"
    },
    {
      "kind": "box",
      "center": [
        0,
        3,
        -39.75
      ],
      "halfExtents": [
        45,
        3,
        0.25
      ],
      "material": "brick",
      "note": "perimeter north wall"
    },
    {
      "kind": "box",
      "center": [
        0,
        3,
        39.75
      ],
      "halfExtents": [
        45,
        3,
        0.25
      ],
      "material": "brick",
      "note": "perimeter south wall"
    },
    {
      "kind": "box",
      "center": [
        44.75,
        3,
        0
      ],
      "halfExtents": [
        0.25,
        3,
        39.5
      ],
      "material": "brick",
      "note": "perimeter east wall"
    },
    {
      "kind": "box",
      "center": [
        -44.75,
        3,
        0
      ],
      "halfExtents": [
        0.25,
        3,
        39.5
      ],
      "material": "brick",
      "note": "perimeter west wall"
    },
    {
      "kind": "box",
      "center": [
        33.25,
        -0.14,
        31.75
      ],
      "halfExtents": [
        11.25,
        0.15,
        7.75
      ],
      "material": "gravel",
      "note": "T road"
    },
    {
      "kind": "box",
      "center": [
        -35.25,
        -0.14,
        -31.75
      ],
      "halfExtents": [
        9.25,
        0.15,
        7.75
      ],
      "material": "gravel",
      "note": "CT yard"
    },
    {
      "kind": "box",
      "center": [
        -42.25,
        -0.14,
        4
      ],
      "halfExtents": [
        2.25,
        0.15,
        10
      ],
      "material": "tile",
      "note": "A plaza west"
    },
    {
      "kind": "box",
      "center": [
        -22,
        -0.14,
        4
      ],
      "halfExtents": [
        12,
        0.15,
        10
      ],
      "material": "tile",
      "note": "A plaza east"
    },
    {
      "kind": "box",
      "center": [
        -37,
        -0.14,
        0
      ],
      "halfExtents": [
        3,
        0.15,
        6
      ],
      "material": "tile",
      "note": "A plaza north"
    },
    {
      "kind": "box",
      "center": [
        -37,
        -0.14,
        13
      ],
      "halfExtents": [
        3,
        0.15,
        1
      ],
      "material": "tile",
      "note": "A plaza south"
    },
    {
      "kind": "box",
      "center": [
        23,
        -0.14,
        -28.75
      ],
      "halfExtents": [
        11,
        0.15,
        10.75
      ],
      "material": "tile",
      "note": "B courtyard"
    },
    {
      "kind": "box",
      "center": [
        2,
        -0.14,
        1
      ],
      "halfExtents": [
        8,
        0.15,
        9
      ],
      "material": "tile",
      "note": "mid plaza"
    },
    {
      "kind": "box",
      "center": [
        -11.25,
        -0.14,
        31.5
      ],
      "halfExtents": [
        33.25,
        0.15,
        3.5
      ],
      "material": "gravel",
      "note": "A long"
    },
    {
      "kind": "box",
      "center": [
        -40.25,
        -0.14,
        21
      ],
      "halfExtents": [
        4.25,
        0.15,
        7
      ],
      "material": "gravel",
      "note": "A long, north leg"
    },
    {
      "kind": "box",
      "center": [
        -37.25,
        -0.14,
        -15
      ],
      "halfExtents": [
        7.25,
        0.15,
        9
      ],
      "material": "gravel",
      "note": "graveyard"
    },
    {
      "kind": "box",
      "center": [
        -16,
        3,
        -34.75
      ],
      "halfExtents": [
        10,
        3,
        4.75
      ],
      "material": "plaster",
      "note": "north terrace west"
    },
    {
      "kind": "box",
      "center": [
        -16,
        6.175,
        -34.75
      ],
      "halfExtents": [
        9.7,
        0.175,
        4.45
      ],
      "material": "tile",
      "note": "north terrace west roof"
    },
    {
      "kind": "box",
      "center": [
        3,
        2.75,
        -34.75
      ],
      "halfExtents": [
        9,
        2.75,
        4.75
      ],
      "material": "plaster",
      "note": "north terrace east"
    },
    {
      "kind": "box",
      "center": [
        3,
        5.675,
        -34.75
      ],
      "halfExtents": [
        8.7,
        0.175,
        4.45
      ],
      "material": "tile",
      "note": "north terrace east roof"
    },
    {
      "kind": "box",
      "center": [
        39.25,
        3.25,
        -28.75
      ],
      "halfExtents": [
        5.25,
        3.25,
        10.75
      ],
      "material": "plaster",
      "note": "B east house"
    },
    {
      "kind": "box",
      "center": [
        39.25,
        6.675,
        -28.75
      ],
      "halfExtents": [
        4.95,
        0.175,
        10.45
      ],
      "material": "tile",
      "note": "B east house roof"
    },
    {
      "kind": "box",
      "center": [
        40.25,
        2.5,
        -12
      ],
      "halfExtents": [
        4.25,
        2.5,
        6
      ],
      "material": "plaster",
      "note": "banana east house"
    },
    {
      "kind": "box",
      "center": [
        40.25,
        5.175,
        -12
      ],
      "halfExtents": [
        3.95,
        0.175,
        5.7
      ],
      "material": "tile",
      "note": "banana east house roof"
    },
    {
      "kind": "box",
      "center": [
        21,
        3,
        -13
      ],
      "halfExtents": [
        9,
        3,
        5
      ],
      "material": "plaster",
      "note": "B south house"
    },
    {
      "kind": "box",
      "center": [
        21,
        6.175,
        -13
      ],
      "halfExtents": [
        8.7,
        0.175,
        4.7
      ],
      "material": "tile",
      "note": "B south house roof"
    },
    {
      "kind": "box",
      "center": [
        15,
        3.25,
        1
      ],
      "halfExtents": [
        5,
        3.25,
        9
      ],
      "material": "plaster",
      "note": "mid east house"
    },
    {
      "kind": "box",
      "center": [
        15,
        6.675,
        1
      ],
      "halfExtents": [
        4.7,
        0.175,
        8.7
      ],
      "material": "tile",
      "note": "mid east house roof"
    },
    {
      "kind": "box",
      "center": [
        25,
        2.75,
        1
      ],
      "halfExtents": [
        5,
        2.75,
        9
      ],
      "material": "plaster",
      "note": "mid east house 2"
    },
    {
      "kind": "box",
      "center": [
        25,
        5.675,
        1
      ],
      "halfExtents": [
        4.7,
        0.175,
        8.7
      ],
      "material": "tile",
      "note": "mid east house 2 roof"
    },
    {
      "kind": "box",
      "center": [
        32,
        3,
        5
      ],
      "halfExtents": [
        4,
        3,
        5
      ],
      "material": "plaster",
      "note": "banana west house"
    },
    {
      "kind": "box",
      "center": [
        32,
        6.175,
        5
      ],
      "halfExtents": [
        3.7,
        0.175,
        4.7
      ],
      "material": "tile",
      "note": "banana west house roof"
    },
    {
      "kind": "box",
      "center": [
        11,
        3,
        21
      ],
      "halfExtents": [
        11,
        3,
        7
      ],
      "material": "plaster",
      "note": "south mid house"
    },
    {
      "kind": "box",
      "center": [
        11,
        6.175,
        21
      ],
      "halfExtents": [
        10.7,
        0.175,
        6.7
      ],
      "material": "tile",
      "note": "south mid house roof"
    },
    {
      "kind": "box",
      "center": [
        -30,
        2.5,
        21
      ],
      "halfExtents": [
        6,
        2.5,
        7
      ],
      "material": "plaster",
      "note": "A south house"
    },
    {
      "kind": "box",
      "center": [
        -30,
        5.175,
        21
      ],
      "halfExtents": [
        5.7,
        0.175,
        6.7
      ],
      "material": "tile",
      "note": "A south house roof"
    },
    {
      "kind": "box",
      "center": [
        -18,
        2.75,
        21
      ],
      "halfExtents": [
        6,
        2.75,
        7
      ],
      "material": "plaster",
      "note": "A south house 2"
    },
    {
      "kind": "box",
      "center": [
        -18,
        5.675,
        21
      ],
      "halfExtents": [
        5.7,
        0.175,
        6.7
      ],
      "material": "tile",
      "note": "A south house 2 roof"
    },
    {
      "kind": "box",
      "center": [
        -6,
        2.25,
        25
      ],
      "halfExtents": [
        6,
        2.25,
        3
      ],
      "material": "plaster",
      "note": "apartments annex"
    },
    {
      "kind": "box",
      "center": [
        -6,
        4.675,
        25
      ],
      "halfExtents": [
        5.7,
        0.175,
        2.7
      ],
      "material": "tile",
      "note": "apartments annex roof"
    },
    {
      "kind": "box",
      "center": [
        -11.25,
        2,
        37.25
      ],
      "halfExtents": [
        33.25,
        2,
        2.25
      ],
      "material": "brick",
      "note": "south row"
    },
    {
      "kind": "box",
      "center": [
        -11.25,
        4.175,
        37.25
      ],
      "halfExtents": [
        32.95,
        0.175,
        1.95
      ],
      "material": "tile",
      "note": "south row roof"
    },
    {
      "kind": "box",
      "center": [
        -21.5,
        4.5,
        -23.75
      ],
      "halfExtents": [
        8.5,
        4.5,
        0.25
      ],
      "material": "plaster",
      "note": "church north wall"
    },
    {
      "kind": "box",
      "center": [
        -29,
        4.5,
        -6.25
      ],
      "halfExtents": [
        1,
        4.5,
        0.25
      ],
      "material": "plaster",
      "note": "church south wall"
    },
    {
      "kind": "box",
      "center": [
        -27.25,
        1.75,
        -6.25
      ],
      "halfExtents": [
        0.75,
        1.75,
        0.25
      ],
      "material": "plaster",
      "note": "church south sill"
    },
    {
      "kind": "box",
      "center": [
        -27.25,
        8,
        -6.25
      ],
      "halfExtents": [
        0.75,
        1,
        0.25
      ],
      "material": "plaster",
      "note": "church south lintel"
    },
    {
      "kind": "box",
      "center": [
        -24.75,
        4.5,
        -6.25
      ],
      "halfExtents": [
        1.75,
        4.5,
        0.25
      ],
      "material": "plaster",
      "note": "church south wall"
    },
    {
      "kind": "box",
      "center": [
        -21.5,
        6.25,
        -6.25
      ],
      "halfExtents": [
        1.5,
        2.75,
        0.25
      ],
      "material": "plaster",
      "note": "church south lintel"
    },
    {
      "kind": "box",
      "center": [
        -18.25,
        4.5,
        -6.25
      ],
      "halfExtents": [
        1.75,
        4.5,
        0.25
      ],
      "material": "plaster",
      "note": "church south wall"
    },
    {
      "kind": "box",
      "center": [
        -15.75,
        1.75,
        -6.25
      ],
      "halfExtents": [
        0.75,
        1.75,
        0.25
      ],
      "material": "plaster",
      "note": "church south sill"
    },
    {
      "kind": "box",
      "center": [
        -15.75,
        8,
        -6.25
      ],
      "halfExtents": [
        0.75,
        1,
        0.25
      ],
      "material": "plaster",
      "note": "church south lintel"
    },
    {
      "kind": "box",
      "center": [
        -14,
        4.5,
        -6.25
      ],
      "halfExtents": [
        1,
        4.5,
        0.25
      ],
      "material": "plaster",
      "note": "church south wall"
    },
    {
      "kind": "box",
      "center": [
        -13.25,
        4.5,
        -21.75
      ],
      "halfExtents": [
        0.25,
        4.5,
        1.75
      ],
      "material": "plaster",
      "note": "church east wall"
    },
    {
      "kind": "box",
      "center": [
        -13.25,
        1.5,
        -19
      ],
      "halfExtents": [
        0.25,
        1.5,
        1
      ],
      "material": "plaster",
      "note": "church east sill"
    },
    {
      "kind": "box",
      "center": [
        -13.25,
        7.5,
        -19
      ],
      "halfExtents": [
        0.25,
        1.5,
        1
      ],
      "material": "plaster",
      "note": "church east lintel"
    },
    {
      "kind": "box",
      "center": [
        -13.25,
        4.5,
        -15
      ],
      "halfExtents": [
        0.25,
        4.5,
        3
      ],
      "material": "plaster",
      "note": "church east wall"
    },
    {
      "kind": "box",
      "center": [
        -13.25,
        1.5,
        -11
      ],
      "halfExtents": [
        0.25,
        1.5,
        1
      ],
      "material": "plaster",
      "note": "church east sill"
    },
    {
      "kind": "box",
      "center": [
        -13.25,
        7.5,
        -11
      ],
      "halfExtents": [
        0.25,
        1.5,
        1
      ],
      "material": "plaster",
      "note": "church east lintel"
    },
    {
      "kind": "box",
      "center": [
        -13.25,
        4.5,
        -8.25
      ],
      "halfExtents": [
        0.25,
        4.5,
        1.75
      ],
      "material": "plaster",
      "note": "church east wall"
    },
    {
      "kind": "box",
      "center": [
        -29.75,
        4.5,
        -20.25
      ],
      "halfExtents": [
        0.25,
        4.5,
        3.25
      ],
      "material": "plaster",
      "note": "church west wall"
    },
    {
      "kind": "box",
      "center": [
        -29.75,
        5.8,
        -15.5
      ],
      "halfExtents": [
        0.25,
        3.2,
        1.5
      ],
      "material": "plaster",
      "note": "church west lintel"
    },
    {
      "kind": "box",
      "center": [
        -29.75,
        4.5,
        -10.25
      ],
      "halfExtents": [
        0.25,
        4.5,
        3.75
      ],
      "material": "plaster",
      "note": "church west wall"
    },
    {
      "kind": "box",
      "center": [
        -21.5,
        9.2,
        -15
      ],
      "halfExtents": [
        8.5,
        0.2,
        9
      ],
      "material": "tile",
      "note": "church roof"
    },
    {
      "kind": "box",
      "center": [
        -14.75,
        7,
        -22.25
      ],
      "halfExtents": [
        1.75,
        7,
        1.75
      ],
      "material": "plaster",
      "note": "bell tower"
    },
    {
      "kind": "box",
      "center": [
        -14.75,
        14.3,
        -22.25
      ],
      "halfExtents": [
        1.45,
        0.3,
        1.45
      ],
      "material": "tile",
      "note": "bell tower roof"
    },
    {
      "kind": "box",
      "center": [
        -21.5,
        0.5,
        -22.25
      ],
      "halfExtents": [
        2,
        0.5,
        0.75
      ],
      "material": "tile",
      "note": "altar"
    },
    {
      "kind": "box",
      "center": [
        -25.5,
        0.45,
        -18
      ],
      "halfExtents": [
        1.5,
        0.45,
        0.4
      ],
      "material": "wood",
      "note": "pew"
    },
    {
      "kind": "box",
      "center": [
        -17.5,
        0.45,
        -18
      ],
      "halfExtents": [
        1.5,
        0.45,
        0.4
      ],
      "material": "wood",
      "note": "pew"
    },
    {
      "kind": "box",
      "center": [
        -25.5,
        0.45,
        -15
      ],
      "halfExtents": [
        1.5,
        0.45,
        0.4
      ],
      "material": "wood",
      "note": "pew"
    },
    {
      "kind": "box",
      "center": [
        -17.5,
        0.45,
        -15
      ],
      "halfExtents": [
        1.5,
        0.45,
        0.4
      ],
      "material": "wood",
      "note": "pew"
    },
    {
      "kind": "box",
      "center": [
        -25.5,
        0.45,
        -12
      ],
      "halfExtents": [
        1.5,
        0.45,
        0.4
      ],
      "material": "wood",
      "note": "pew"
    },
    {
      "kind": "box",
      "center": [
        -17.5,
        0.45,
        -12
      ],
      "halfExtents": [
        1.5,
        0.45,
        0.4
      ],
      "material": "wood",
      "note": "pew"
    },
    {
      "kind": "box",
      "center": [
        -21.5,
        3.6,
        -22.2
      ],
      "halfExtents": [
        0.2,
        0.06,
        0.2
      ],
      "material": "metal",
      "emissive": "#ffd9a8",
      "emissiveIntensity": 3,
      "note": "altar lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -21.5,
        3.9,
        -6.9
      ],
      "halfExtents": [
        0.18,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#ffd9a8",
      "emissiveIntensity": 3,
      "note": "church door lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -29.1,
        2.9,
        -15.5
      ],
      "halfExtents": [
        0.18,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#ffd9a8",
      "emissiveIntensity": 3,
      "note": "church side door lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -6.5,
        2,
        -23.8
      ],
      "halfExtents": [
        3.5,
        2,
        0.2
      ],
      "material": "plaster",
      "note": "library north wall"
    },
    {
      "kind": "box",
      "center": [
        -2,
        3.1,
        -23.8
      ],
      "halfExtents": [
        1,
        0.9,
        0.2
      ],
      "material": "plaster",
      "note": "library north lintel"
    },
    {
      "kind": "box",
      "center": [
        2.5,
        2,
        -23.8
      ],
      "halfExtents": [
        3.5,
        2,
        0.2
      ],
      "material": "plaster",
      "note": "library north wall"
    },
    {
      "kind": "box",
      "center": [
        -6.5,
        2,
        -8.2
      ],
      "halfExtents": [
        3.5,
        2,
        0.2
      ],
      "material": "plaster",
      "note": "library south wall"
    },
    {
      "kind": "box",
      "center": [
        -2,
        3.1,
        -8.2
      ],
      "halfExtents": [
        1,
        0.9,
        0.2
      ],
      "material": "plaster",
      "note": "library south lintel"
    },
    {
      "kind": "box",
      "center": [
        2.5,
        2,
        -8.2
      ],
      "halfExtents": [
        3.5,
        2,
        0.2
      ],
      "material": "plaster",
      "note": "library south wall"
    },
    {
      "kind": "box",
      "center": [
        5.8,
        2,
        -20.8
      ],
      "halfExtents": [
        0.2,
        2,
        2.8
      ],
      "material": "plaster",
      "note": "library east wall"
    },
    {
      "kind": "box",
      "center": [
        5.8,
        0.5,
        -16.5
      ],
      "halfExtents": [
        0.2,
        0.5,
        1.5
      ],
      "material": "plaster",
      "note": "library east sill"
    },
    {
      "kind": "box",
      "center": [
        5.8,
        3.1,
        -16.5
      ],
      "halfExtents": [
        0.2,
        0.9,
        1.5
      ],
      "material": "plaster",
      "note": "library east lintel"
    },
    {
      "kind": "box",
      "center": [
        5.8,
        2,
        -11.7
      ],
      "halfExtents": [
        0.2,
        2,
        3.3
      ],
      "material": "plaster",
      "note": "library east wall"
    },
    {
      "kind": "box",
      "center": [
        -9.8,
        2,
        -20.8
      ],
      "halfExtents": [
        0.2,
        2,
        2.8
      ],
      "material": "plaster",
      "note": "library west wall"
    },
    {
      "kind": "box",
      "center": [
        -9.8,
        0.5,
        -16.5
      ],
      "halfExtents": [
        0.2,
        0.5,
        1.5
      ],
      "material": "plaster",
      "note": "library west sill"
    },
    {
      "kind": "box",
      "center": [
        -9.8,
        3.1,
        -16.5
      ],
      "halfExtents": [
        0.2,
        0.9,
        1.5
      ],
      "material": "plaster",
      "note": "library west lintel"
    },
    {
      "kind": "box",
      "center": [
        -9.8,
        2,
        -11.7
      ],
      "halfExtents": [
        0.2,
        2,
        3.3
      ],
      "material": "plaster",
      "note": "library west wall"
    },
    {
      "kind": "box",
      "center": [
        -2,
        4.15,
        -16
      ],
      "halfExtents": [
        8,
        0.15,
        8
      ],
      "material": "tile",
      "note": "library roof"
    },
    {
      "kind": "box",
      "center": [
        -9.3,
        1.1,
        -21.1
      ],
      "halfExtents": [
        0.3,
        1.1,
        2.1
      ],
      "material": "wood",
      "note": "bookshelf"
    },
    {
      "kind": "box",
      "center": [
        5.3,
        1.1,
        -10.9
      ],
      "halfExtents": [
        0.3,
        1.1,
        2.1
      ],
      "material": "wood",
      "note": "bookshelf"
    },
    {
      "kind": "box",
      "center": [
        -2,
        0.4,
        -18
      ],
      "halfExtents": [
        1.2,
        0.4,
        0.6
      ],
      "material": "wood",
      "note": "reading table"
    },
    {
      "kind": "box",
      "center": [
        2,
        0.4,
        -13
      ],
      "halfExtents": [
        1.2,
        0.4,
        0.6
      ],
      "material": "wood",
      "note": "reading table"
    },
    {
      "kind": "box",
      "center": [
        -2,
        3.5,
        -16
      ],
      "halfExtents": [
        0.2,
        0.05,
        0.2
      ],
      "material": "metal",
      "emissive": "#ffe3b0",
      "emissiveIntensity": 3,
      "note": "library lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -2,
        2.7,
        -7.6
      ],
      "halfExtents": [
        0.18,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#ffd9a8",
      "emissiveIntensity": 3,
      "note": "library south door lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -2,
        2.7,
        -24.4
      ],
      "halfExtents": [
        0.18,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#ffd9a8",
      "emissiveIntensity": 3,
      "note": "library north door lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -8,
        2.5,
        -5.25
      ],
      "halfExtents": [
        2,
        2.5,
        2.75
      ],
      "material": "plaster",
      "note": "arch pier south"
    },
    {
      "kind": "box",
      "center": [
        -8,
        2.5,
        5.5
      ],
      "halfExtents": [
        2,
        2.5,
        4.5
      ],
      "material": "plaster",
      "note": "arch pier north"
    },
    {
      "kind": "box",
      "center": [
        -8,
        3.9,
        -0.75
      ],
      "halfExtents": [
        2,
        0.7,
        1.75
      ],
      "material": "plaster",
      "note": "arch vault"
    },
    {
      "kind": "box",
      "center": [
        -8,
        3,
        -0.75
      ],
      "halfExtents": [
        0.3,
        0.05,
        0.15
      ],
      "material": "metal",
      "emissive": "#ffd9a8",
      "emissiveIntensity": 3,
      "note": "arch lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        11.8,
        1.75,
        -21
      ],
      "halfExtents": [
        0.2,
        1.75,
        3
      ],
      "material": "plaster",
      "note": "B garden wall"
    },
    {
      "kind": "box",
      "center": [
        22,
        0.55,
        -28.2
      ],
      "halfExtents": [
        4,
        0.55,
        0.2
      ],
      "material": "brick",
      "note": "B low wall"
    },
    {
      "kind": "box",
      "center": [
        28,
        0.6,
        -33
      ],
      "halfExtents": [
        0.6,
        0.6,
        0.6
      ],
      "material": "wood",
      "hidden": true,
      "note": "prop collision"
    },
    {
      "kind": "box",
      "center": [
        29.4,
        0.4,
        -33.2
      ],
      "halfExtents": [
        0.6,
        0.4,
        0.4
      ],
      "material": "wood",
      "hidden": true,
      "note": "prop collision"
    },
    {
      "kind": "box",
      "center": [
        15.5,
        0.2,
        -35
      ],
      "halfExtents": [
        0.7,
        0.2,
        0.5
      ],
      "material": "wood",
      "hidden": true,
      "note": "prop collision"
    },
    {
      "kind": "box",
      "center": [
        15.5,
        0.8,
        -35
      ],
      "halfExtents": [
        0.6,
        0.4,
        0.4
      ],
      "material": "wood",
      "hidden": true,
      "note": "prop collision"
    },
    {
      "kind": "box",
      "center": [
        22,
        0.5,
        -22
      ],
      "halfExtents": [
        0.7,
        0.5,
        0.6
      ],
      "material": "wood",
      "hidden": true,
      "note": "prop collision"
    },
    {
      "kind": "box",
      "center": [
        12,
        2.9,
        -27
      ],
      "halfExtents": [
        0.18,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#ffd9a8",
      "emissiveIntensity": 3,
      "note": "B gate lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        32,
        2.9,
        -18.5
      ],
      "halfExtents": [
        0.18,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#ffd9a8",
      "emissiveIntensity": 3,
      "note": "banana mouth lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        23,
        4,
        -30
      ],
      "halfExtents": [
        0.2,
        0.06,
        0.2
      ],
      "material": "metal",
      "emissive": "#fff1d6",
      "emissiveIntensity": 3,
      "note": "B site lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        43.5,
        0.6,
        8
      ],
      "halfExtents": [
        0.6,
        0.6,
        0.6
      ],
      "material": "wood",
      "hidden": true,
      "note": "prop collision"
    },
    {
      "kind": "box",
      "center": [
        31,
        0.4,
        -12
      ],
      "halfExtents": [
        0.6,
        0.4,
        0.4
      ],
      "material": "wood",
      "hidden": true,
      "note": "prop collision"
    },
    {
      "kind": "box",
      "center": [
        39,
        2.9,
        0.4
      ],
      "halfExtents": [
        0.18,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#ffd9a8",
      "emissiveIntensity": 3,
      "note": "banana bend lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        3,
        0.35,
        4
      ],
      "halfExtents": [
        1.2,
        0.35,
        1.2
      ],
      "material": "tile",
      "note": "well"
    },
    {
      "kind": "box",
      "center": [
        -3,
        0.4,
        -5
      ],
      "halfExtents": [
        0.6,
        0.4,
        0.4
      ],
      "material": "wood",
      "hidden": true,
      "note": "prop collision"
    },
    {
      "kind": "box",
      "center": [
        3,
        3,
        4
      ],
      "halfExtents": [
        0.12,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#ffe3b0",
      "emissiveIntensity": 3,
      "note": "well lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        8,
        2.7,
        -7.6
      ],
      "halfExtents": [
        0.18,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#ffd9a8",
      "emissiveIntensity": 3,
      "note": "alley mouth lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -8,
        0.4,
        -29.3
      ],
      "halfExtents": [
        0.6,
        0.4,
        0.4
      ],
      "material": "wood",
      "hidden": true,
      "note": "prop collision"
    },
    {
      "kind": "box",
      "center": [
        -26.4,
        3,
        -27
      ],
      "halfExtents": [
        0.18,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#ffd9a8",
      "emissiveIntensity": 3,
      "note": "corridor mouth lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -6,
        3,
        -29.6
      ],
      "halfExtents": [
        0.18,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#ffd9a8",
      "emissiveIntensity": 3,
      "note": "corridor lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -42,
        0.45,
        -19
      ],
      "halfExtents": [
        0.5,
        0.45,
        0.9
      ],
      "material": "brick",
      "note": "tomb"
    },
    {
      "kind": "box",
      "center": [
        -39,
        0.45,
        -19
      ],
      "halfExtents": [
        0.5,
        0.45,
        0.9
      ],
      "material": "brick",
      "note": "tomb"
    },
    {
      "kind": "box",
      "center": [
        -36,
        0.45,
        -19
      ],
      "halfExtents": [
        0.5,
        0.45,
        0.9
      ],
      "material": "brick",
      "note": "tomb"
    },
    {
      "kind": "box",
      "center": [
        -33,
        0.45,
        -19
      ],
      "halfExtents": [
        0.5,
        0.45,
        0.9
      ],
      "material": "brick",
      "note": "tomb"
    },
    {
      "kind": "box",
      "center": [
        -42,
        0.45,
        -15
      ],
      "halfExtents": [
        0.5,
        0.45,
        0.9
      ],
      "material": "brick",
      "note": "tomb"
    },
    {
      "kind": "box",
      "center": [
        -39,
        0.45,
        -15
      ],
      "halfExtents": [
        0.5,
        0.45,
        0.9
      ],
      "material": "brick",
      "note": "tomb"
    },
    {
      "kind": "box",
      "center": [
        -36,
        0.45,
        -15
      ],
      "halfExtents": [
        0.5,
        0.45,
        0.9
      ],
      "material": "brick",
      "note": "tomb"
    },
    {
      "kind": "box",
      "center": [
        -33,
        0.45,
        -15
      ],
      "halfExtents": [
        0.5,
        0.45,
        0.9
      ],
      "material": "brick",
      "note": "tomb"
    },
    {
      "kind": "box",
      "center": [
        -42,
        0.45,
        -11
      ],
      "halfExtents": [
        0.5,
        0.45,
        0.9
      ],
      "material": "brick",
      "note": "tomb"
    },
    {
      "kind": "box",
      "center": [
        -39,
        0.45,
        -11
      ],
      "halfExtents": [
        0.5,
        0.45,
        0.9
      ],
      "material": "brick",
      "note": "tomb"
    },
    {
      "kind": "box",
      "center": [
        -36,
        0.45,
        -11
      ],
      "halfExtents": [
        0.5,
        0.45,
        0.9
      ],
      "material": "brick",
      "note": "tomb"
    },
    {
      "kind": "box",
      "center": [
        -33,
        0.45,
        -11
      ],
      "halfExtents": [
        0.5,
        0.45,
        0.9
      ],
      "material": "brick",
      "note": "tomb"
    },
    {
      "kind": "box",
      "center": [
        -40.75,
        1.5,
        -6.25
      ],
      "halfExtents": [
        3.75,
        1.5,
        0.25
      ],
      "material": "brick",
      "note": "graveyard wall west"
    },
    {
      "kind": "box",
      "center": [
        -31.5,
        1.5,
        -6.25
      ],
      "halfExtents": [
        1.5,
        1.5,
        0.25
      ],
      "material": "brick",
      "note": "graveyard wall east"
    },
    {
      "kind": "box",
      "center": [
        -26,
        0.6,
        -1.75
      ],
      "halfExtents": [
        4,
        0.6,
        0.25
      ],
      "material": "brick",
      "note": "A planter wall"
    },
    {
      "kind": "box",
      "center": [
        -16,
        0.6,
        8
      ],
      "halfExtents": [
        0.6,
        0.6,
        0.6
      ],
      "material": "wood",
      "hidden": true,
      "note": "prop collision"
    },
    {
      "kind": "box",
      "center": [
        -17.4,
        0.4,
        8.4
      ],
      "halfExtents": [
        0.6,
        0.4,
        0.4
      ],
      "material": "wood",
      "hidden": true,
      "note": "prop collision"
    },
    {
      "kind": "box",
      "center": [
        -30,
        0.2,
        12
      ],
      "halfExtents": [
        0.7,
        0.2,
        0.5
      ],
      "material": "wood",
      "hidden": true,
      "note": "prop collision"
    },
    {
      "kind": "box",
      "center": [
        -26,
        4.5,
        2
      ],
      "halfExtents": [
        0.2,
        0.06,
        0.2
      ],
      "material": "metal",
      "emissive": "#fff1d6",
      "emissiveIntensity": 3,
      "note": "A site lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -35,
        2.4,
        13.6
      ],
      "halfExtents": [
        0.18,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#ffd9a8",
      "emissiveIntensity": 3,
      "note": "A long mouth lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -9.5,
        1.45,
        10.15
      ],
      "halfExtents": [
        2.5,
        1.45,
        0.15
      ],
      "material": "plaster",
      "note": "apartments north wall"
    },
    {
      "kind": "box",
      "center": [
        -6,
        2.55,
        10.15
      ],
      "halfExtents": [
        1,
        0.35,
        0.15
      ],
      "material": "plaster",
      "note": "apartments north lintel"
    },
    {
      "kind": "box",
      "center": [
        -2.5,
        1.45,
        10.15
      ],
      "halfExtents": [
        2.5,
        1.45,
        0.15
      ],
      "material": "plaster",
      "note": "apartments north wall"
    },
    {
      "kind": "box",
      "center": [
        -6,
        1.45,
        21.85
      ],
      "halfExtents": [
        6,
        1.45,
        0.15
      ],
      "material": "plaster",
      "note": "apartments south wall"
    },
    {
      "kind": "box",
      "center": [
        -0.15,
        1.45,
        10.65
      ],
      "halfExtents": [
        0.15,
        1.45,
        0.35
      ],
      "material": "plaster",
      "note": "apartments east wall"
    },
    {
      "kind": "box",
      "center": [
        -0.15,
        2.55,
        12
      ],
      "halfExtents": [
        0.15,
        0.35,
        1
      ],
      "material": "plaster",
      "note": "apartments east lintel"
    },
    {
      "kind": "box",
      "center": [
        -0.15,
        1.45,
        17.35
      ],
      "halfExtents": [
        0.15,
        1.45,
        4.35
      ],
      "material": "plaster",
      "note": "apartments east wall"
    },
    {
      "kind": "box",
      "center": [
        -11.85,
        1.45,
        11.15
      ],
      "halfExtents": [
        0.15,
        1.45,
        0.85
      ],
      "material": "plaster",
      "note": "apartments west wall"
    },
    {
      "kind": "box",
      "center": [
        -11.85,
        0.5,
        12.75
      ],
      "halfExtents": [
        0.15,
        0.5,
        0.75
      ],
      "material": "plaster",
      "note": "apartments west sill"
    },
    {
      "kind": "box",
      "center": [
        -11.85,
        2.45,
        12.75
      ],
      "halfExtents": [
        0.15,
        0.45,
        0.75
      ],
      "material": "plaster",
      "note": "apartments west lintel"
    },
    {
      "kind": "box",
      "center": [
        -11.85,
        1.45,
        17.6
      ],
      "halfExtents": [
        0.15,
        1.45,
        4.1
      ],
      "material": "plaster",
      "note": "apartments west wall"
    },
    {
      "kind": "box",
      "center": [
        -10.8,
        0.075,
        19.388
      ],
      "halfExtents": [
        0.7,
        0.075,
        0.113
      ],
      "material": "wood",
      "note": "apartments stair step 1"
    },
    {
      "kind": "box",
      "center": [
        -10.8,
        0.15,
        19.163
      ],
      "halfExtents": [
        0.7,
        0.15,
        0.113
      ],
      "material": "wood",
      "note": "apartments stair step 2"
    },
    {
      "kind": "box",
      "center": [
        -10.8,
        0.225,
        18.938
      ],
      "halfExtents": [
        0.7,
        0.225,
        0.113
      ],
      "material": "wood",
      "note": "apartments stair step 3"
    },
    {
      "kind": "box",
      "center": [
        -10.8,
        0.3,
        18.713
      ],
      "halfExtents": [
        0.7,
        0.3,
        0.113
      ],
      "material": "wood",
      "note": "apartments stair step 4"
    },
    {
      "kind": "box",
      "center": [
        -10.8,
        0.375,
        18.488
      ],
      "halfExtents": [
        0.7,
        0.375,
        0.113
      ],
      "material": "wood",
      "note": "apartments stair step 5"
    },
    {
      "kind": "box",
      "center": [
        -10.8,
        0.45,
        18.263
      ],
      "halfExtents": [
        0.7,
        0.45,
        0.113
      ],
      "material": "wood",
      "note": "apartments stair step 6"
    },
    {
      "kind": "box",
      "center": [
        -10.8,
        0.525,
        18.038
      ],
      "halfExtents": [
        0.7,
        0.525,
        0.113
      ],
      "material": "wood",
      "note": "apartments stair step 7"
    },
    {
      "kind": "box",
      "center": [
        -10.8,
        0.6,
        17.813
      ],
      "halfExtents": [
        0.7,
        0.6,
        0.113
      ],
      "material": "wood",
      "note": "apartments stair step 8"
    },
    {
      "kind": "box",
      "center": [
        -10.8,
        0.675,
        17.588
      ],
      "halfExtents": [
        0.7,
        0.675,
        0.113
      ],
      "material": "wood",
      "note": "apartments stair step 9"
    },
    {
      "kind": "box",
      "center": [
        -10.8,
        0.75,
        17.363
      ],
      "halfExtents": [
        0.7,
        0.75,
        0.113
      ],
      "material": "wood",
      "note": "apartments stair step 10"
    },
    {
      "kind": "box",
      "center": [
        -10.8,
        0.825,
        17.138
      ],
      "halfExtents": [
        0.7,
        0.825,
        0.113
      ],
      "material": "wood",
      "note": "apartments stair step 11"
    },
    {
      "kind": "box",
      "center": [
        -10.8,
        0.9,
        16.913
      ],
      "halfExtents": [
        0.7,
        0.9,
        0.113
      ],
      "material": "wood",
      "note": "apartments stair step 12"
    },
    {
      "kind": "box",
      "center": [
        -10.8,
        0.975,
        16.688
      ],
      "halfExtents": [
        0.7,
        0.975,
        0.113
      ],
      "material": "wood",
      "note": "apartments stair step 13"
    },
    {
      "kind": "box",
      "center": [
        -10.8,
        1.05,
        16.463
      ],
      "halfExtents": [
        0.7,
        1.05,
        0.113
      ],
      "material": "wood",
      "note": "apartments stair step 14"
    },
    {
      "kind": "box",
      "center": [
        -10.8,
        1.125,
        16.238
      ],
      "halfExtents": [
        0.7,
        1.125,
        0.113
      ],
      "material": "wood",
      "note": "apartments stair step 15"
    },
    {
      "kind": "box",
      "center": [
        -10.8,
        1.2,
        16.013
      ],
      "halfExtents": [
        0.7,
        1.2,
        0.113
      ],
      "material": "wood",
      "note": "apartments stair step 16"
    },
    {
      "kind": "box",
      "center": [
        -10.8,
        1.275,
        15.788
      ],
      "halfExtents": [
        0.7,
        1.275,
        0.113
      ],
      "material": "wood",
      "note": "apartments stair step 17"
    },
    {
      "kind": "box",
      "center": [
        -10.8,
        1.35,
        15.563
      ],
      "halfExtents": [
        0.7,
        1.35,
        0.113
      ],
      "material": "wood",
      "note": "apartments stair step 18"
    },
    {
      "kind": "box",
      "center": [
        -10.8,
        1.425,
        15.337
      ],
      "halfExtents": [
        0.7,
        1.425,
        0.113
      ],
      "material": "wood",
      "note": "apartments stair step 19"
    },
    {
      "kind": "box",
      "center": [
        -10.8,
        1.5,
        15.113
      ],
      "halfExtents": [
        0.7,
        1.5,
        0.113
      ],
      "material": "wood",
      "note": "apartments stair step 20"
    },
    {
      "kind": "box",
      "center": [
        -10.8,
        1.575,
        14.888
      ],
      "halfExtents": [
        0.7,
        1.575,
        0.113
      ],
      "material": "wood",
      "note": "apartments stair step 21"
    },
    {
      "kind": "box",
      "center": [
        -10.8,
        1.59,
        14.663
      ],
      "halfExtents": [
        0.7,
        1.59,
        0.113
      ],
      "material": "wood",
      "note": "apartments stair step 22"
    },
    {
      "kind": "box",
      "center": [
        -6,
        3.05,
        12.275
      ],
      "halfExtents": [
        6,
        0.15,
        2.275
      ],
      "material": "wood",
      "note": "apartments deck north"
    },
    {
      "kind": "box",
      "center": [
        -11.85,
        3.05,
        16.525
      ],
      "halfExtents": [
        0.15,
        0.15,
        1.975
      ],
      "material": "wood",
      "note": "apartments deck ledge"
    },
    {
      "kind": "box",
      "center": [
        -4.85,
        3.05,
        16.525
      ],
      "halfExtents": [
        4.85,
        0.15,
        1.975
      ],
      "material": "wood",
      "note": "apartments deck east"
    },
    {
      "kind": "box",
      "center": [
        -6,
        3.05,
        20.25
      ],
      "halfExtents": [
        6,
        0.15,
        1.75
      ],
      "material": "wood",
      "note": "apartments deck south"
    },
    {
      "kind": "box",
      "center": [
        -6,
        3.75,
        10.15
      ],
      "halfExtents": [
        6,
        0.55,
        0.15
      ],
      "material": "plaster",
      "note": "apartments parapet north wall"
    },
    {
      "kind": "box",
      "center": [
        -6,
        3.75,
        21.85
      ],
      "halfExtents": [
        6,
        0.55,
        0.15
      ],
      "material": "plaster",
      "note": "apartments parapet south wall"
    },
    {
      "kind": "box",
      "center": [
        -0.15,
        3.75,
        16
      ],
      "halfExtents": [
        0.15,
        0.55,
        5.7
      ],
      "material": "plaster",
      "note": "apartments parapet east wall"
    },
    {
      "kind": "box",
      "center": [
        -11.85,
        3.75,
        16
      ],
      "halfExtents": [
        0.15,
        0.55,
        5.7
      ],
      "material": "plaster",
      "note": "apartments parapet west wall"
    },
    {
      "kind": "box",
      "center": [
        -4,
        0.4,
        16
      ],
      "halfExtents": [
        1,
        0.4,
        0.6
      ],
      "material": "wood",
      "note": "table"
    },
    {
      "kind": "box",
      "center": [
        -1.2,
        0.8,
        20.8
      ],
      "halfExtents": [
        0.6,
        0.8,
        0.5
      ],
      "material": "brick",
      "note": "hearth"
    },
    {
      "kind": "box",
      "center": [
        -5,
        2.6,
        16
      ],
      "halfExtents": [
        0.15,
        0.04,
        0.15
      ],
      "material": "metal",
      "emissive": "#ffe3b0",
      "emissiveIntensity": 3,
      "note": "apartments lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -6,
        2.7,
        9.6
      ],
      "halfExtents": [
        0.18,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#ffd9a8",
      "emissiveIntensity": 3,
      "note": "apartments north door lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        0.4,
        2.7,
        12
      ],
      "halfExtents": [
        0.18,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#ffd9a8",
      "emissiveIntensity": 3,
      "note": "apartments east door lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        32,
        1.45,
        10.15
      ],
      "halfExtents": [
        4,
        1.45,
        0.15
      ],
      "material": "plaster",
      "note": "banana house north wall"
    },
    {
      "kind": "box",
      "center": [
        29.5,
        1.45,
        23.85
      ],
      "halfExtents": [
        1.5,
        1.45,
        0.15
      ],
      "material": "plaster",
      "note": "banana house south wall"
    },
    {
      "kind": "box",
      "center": [
        32,
        0.5,
        23.85
      ],
      "halfExtents": [
        1,
        0.5,
        0.15
      ],
      "material": "plaster",
      "note": "banana house south sill"
    },
    {
      "kind": "box",
      "center": [
        32,
        2.45,
        23.85
      ],
      "halfExtents": [
        1,
        0.45,
        0.15
      ],
      "material": "plaster",
      "note": "banana house south lintel"
    },
    {
      "kind": "box",
      "center": [
        34.5,
        1.45,
        23.85
      ],
      "halfExtents": [
        1.5,
        1.45,
        0.15
      ],
      "material": "plaster",
      "note": "banana house south wall"
    },
    {
      "kind": "box",
      "center": [
        35.85,
        1.45,
        13.15
      ],
      "halfExtents": [
        0.15,
        1.45,
        2.85
      ],
      "material": "plaster",
      "note": "banana house east wall"
    },
    {
      "kind": "box",
      "center": [
        35.85,
        2.55,
        17
      ],
      "halfExtents": [
        0.15,
        0.35,
        1
      ],
      "material": "plaster",
      "note": "banana house east lintel"
    },
    {
      "kind": "box",
      "center": [
        35.85,
        1.45,
        20.85
      ],
      "halfExtents": [
        0.15,
        1.45,
        2.85
      ],
      "material": "plaster",
      "note": "banana house east wall"
    },
    {
      "kind": "box",
      "center": [
        28.15,
        1.45,
        13.15
      ],
      "halfExtents": [
        0.15,
        1.45,
        2.85
      ],
      "material": "plaster",
      "note": "banana house west wall"
    },
    {
      "kind": "box",
      "center": [
        28.15,
        2.55,
        17
      ],
      "halfExtents": [
        0.15,
        0.35,
        1
      ],
      "material": "plaster",
      "note": "banana house west lintel"
    },
    {
      "kind": "box",
      "center": [
        28.15,
        1.45,
        20.85
      ],
      "halfExtents": [
        0.15,
        1.45,
        2.85
      ],
      "material": "plaster",
      "note": "banana house west wall"
    },
    {
      "kind": "box",
      "center": [
        32,
        3.05,
        17
      ],
      "halfExtents": [
        4,
        0.15,
        7
      ],
      "material": "wood",
      "note": "banana house deck"
    },
    {
      "kind": "box",
      "center": [
        32,
        3.75,
        10.15
      ],
      "halfExtents": [
        4,
        0.55,
        0.15
      ],
      "material": "plaster",
      "note": "banana house parapet north wall"
    },
    {
      "kind": "box",
      "center": [
        32,
        3.75,
        23.85
      ],
      "halfExtents": [
        4,
        0.55,
        0.15
      ],
      "material": "plaster",
      "note": "banana house parapet south wall"
    },
    {
      "kind": "box",
      "center": [
        35.85,
        3.75,
        17
      ],
      "halfExtents": [
        0.15,
        0.55,
        6.7
      ],
      "material": "plaster",
      "note": "banana house parapet east wall"
    },
    {
      "kind": "box",
      "center": [
        28.15,
        3.75,
        12.15
      ],
      "halfExtents": [
        0.15,
        0.55,
        1.85
      ],
      "material": "plaster",
      "note": "banana house parapet west wall"
    },
    {
      "kind": "box",
      "center": [
        28.15,
        3.75,
        20.85
      ],
      "halfExtents": [
        0.15,
        0.55,
        2.85
      ],
      "material": "plaster",
      "note": "banana house parapet west wall"
    },
    {
      "kind": "box",
      "center": [
        27.1,
        0.075,
        22.888
      ],
      "halfExtents": [
        0.7,
        0.075,
        0.113
      ],
      "material": "plaster",
      "note": "banana house stair step 1"
    },
    {
      "kind": "box",
      "center": [
        27.1,
        0.15,
        22.663
      ],
      "halfExtents": [
        0.7,
        0.15,
        0.113
      ],
      "material": "plaster",
      "note": "banana house stair step 2"
    },
    {
      "kind": "box",
      "center": [
        27.1,
        0.225,
        22.438
      ],
      "halfExtents": [
        0.7,
        0.225,
        0.113
      ],
      "material": "plaster",
      "note": "banana house stair step 3"
    },
    {
      "kind": "box",
      "center": [
        27.1,
        0.3,
        22.213
      ],
      "halfExtents": [
        0.7,
        0.3,
        0.113
      ],
      "material": "plaster",
      "note": "banana house stair step 4"
    },
    {
      "kind": "box",
      "center": [
        27.1,
        0.375,
        21.988
      ],
      "halfExtents": [
        0.7,
        0.375,
        0.113
      ],
      "material": "plaster",
      "note": "banana house stair step 5"
    },
    {
      "kind": "box",
      "center": [
        27.1,
        0.45,
        21.763
      ],
      "halfExtents": [
        0.7,
        0.45,
        0.113
      ],
      "material": "plaster",
      "note": "banana house stair step 6"
    },
    {
      "kind": "box",
      "center": [
        27.1,
        0.525,
        21.538
      ],
      "halfExtents": [
        0.7,
        0.525,
        0.113
      ],
      "material": "plaster",
      "note": "banana house stair step 7"
    },
    {
      "kind": "box",
      "center": [
        27.1,
        0.6,
        21.313
      ],
      "halfExtents": [
        0.7,
        0.6,
        0.113
      ],
      "material": "plaster",
      "note": "banana house stair step 8"
    },
    {
      "kind": "box",
      "center": [
        27.1,
        0.675,
        21.088
      ],
      "halfExtents": [
        0.7,
        0.675,
        0.113
      ],
      "material": "plaster",
      "note": "banana house stair step 9"
    },
    {
      "kind": "box",
      "center": [
        27.1,
        0.75,
        20.863
      ],
      "halfExtents": [
        0.7,
        0.75,
        0.113
      ],
      "material": "plaster",
      "note": "banana house stair step 10"
    },
    {
      "kind": "box",
      "center": [
        27.1,
        0.825,
        20.638
      ],
      "halfExtents": [
        0.7,
        0.825,
        0.113
      ],
      "material": "plaster",
      "note": "banana house stair step 11"
    },
    {
      "kind": "box",
      "center": [
        27.1,
        0.9,
        20.413
      ],
      "halfExtents": [
        0.7,
        0.9,
        0.113
      ],
      "material": "plaster",
      "note": "banana house stair step 12"
    },
    {
      "kind": "box",
      "center": [
        27.1,
        0.975,
        20.188
      ],
      "halfExtents": [
        0.7,
        0.975,
        0.113
      ],
      "material": "plaster",
      "note": "banana house stair step 13"
    },
    {
      "kind": "box",
      "center": [
        27.1,
        1.05,
        19.963
      ],
      "halfExtents": [
        0.7,
        1.05,
        0.113
      ],
      "material": "plaster",
      "note": "banana house stair step 14"
    },
    {
      "kind": "box",
      "center": [
        27.1,
        1.125,
        19.738
      ],
      "halfExtents": [
        0.7,
        1.125,
        0.113
      ],
      "material": "plaster",
      "note": "banana house stair step 15"
    },
    {
      "kind": "box",
      "center": [
        27.1,
        1.2,
        19.513
      ],
      "halfExtents": [
        0.7,
        1.2,
        0.113
      ],
      "material": "plaster",
      "note": "banana house stair step 16"
    },
    {
      "kind": "box",
      "center": [
        27.1,
        1.275,
        19.288
      ],
      "halfExtents": [
        0.7,
        1.275,
        0.113
      ],
      "material": "plaster",
      "note": "banana house stair step 17"
    },
    {
      "kind": "box",
      "center": [
        27.1,
        1.35,
        19.063
      ],
      "halfExtents": [
        0.7,
        1.35,
        0.113
      ],
      "material": "plaster",
      "note": "banana house stair step 18"
    },
    {
      "kind": "box",
      "center": [
        27.1,
        1.425,
        18.838
      ],
      "halfExtents": [
        0.7,
        1.425,
        0.113
      ],
      "material": "plaster",
      "note": "banana house stair step 19"
    },
    {
      "kind": "box",
      "center": [
        27.1,
        1.5,
        18.613
      ],
      "halfExtents": [
        0.7,
        1.5,
        0.113
      ],
      "material": "plaster",
      "note": "banana house stair step 20"
    },
    {
      "kind": "box",
      "center": [
        27.1,
        1.575,
        18.388
      ],
      "halfExtents": [
        0.7,
        1.575,
        0.113
      ],
      "material": "plaster",
      "note": "banana house stair step 21"
    },
    {
      "kind": "box",
      "center": [
        27.1,
        1.59,
        18.163
      ],
      "halfExtents": [
        0.7,
        1.59,
        0.113
      ],
      "material": "plaster",
      "note": "banana house stair step 22"
    },
    {
      "kind": "box",
      "center": [
        27.1,
        3.05,
        15.775
      ],
      "halfExtents": [
        0.9,
        0.15,
        2.275
      ],
      "material": "wood",
      "note": "banana house landing"
    },
    {
      "kind": "box",
      "center": [
        26.35,
        3.75,
        15.775
      ],
      "halfExtents": [
        0.15,
        0.55,
        2.275
      ],
      "material": "plaster",
      "note": "landing rail"
    },
    {
      "kind": "box",
      "center": [
        32,
        0.4,
        13
      ],
      "halfExtents": [
        1,
        0.4,
        0.6
      ],
      "material": "wood",
      "note": "table"
    },
    {
      "kind": "box",
      "center": [
        32,
        2.6,
        17
      ],
      "halfExtents": [
        0.15,
        0.04,
        0.15
      ],
      "material": "metal",
      "emissive": "#ffe3b0",
      "emissiveIntensity": 3,
      "note": "banana house lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        27.6,
        2.7,
        15
      ],
      "halfExtents": [
        0.18,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#ffd9a8",
      "emissiveIntensity": 3,
      "note": "banana house west door lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        36.4,
        2.7,
        17
      ],
      "halfExtents": [
        0.18,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#ffd9a8",
      "emissiveIntensity": 3,
      "note": "banana house east door lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -10,
        0.6,
        31.25
      ],
      "halfExtents": [
        2,
        0.6,
        0.75
      ],
      "material": "brick",
      "note": "A long planter"
    },
    {
      "kind": "box",
      "center": [
        8,
        0.5,
        33.8
      ],
      "halfExtents": [
        0.7,
        0.5,
        0.6
      ],
      "material": "wood",
      "hidden": true,
      "note": "prop collision"
    },
    {
      "kind": "box",
      "center": [
        -30,
        0.6,
        29
      ],
      "halfExtents": [
        0.6,
        0.6,
        0.6
      ],
      "material": "wood",
      "hidden": true,
      "note": "prop collision"
    },
    {
      "kind": "box",
      "center": [
        22.4,
        3,
        31.5
      ],
      "halfExtents": [
        0.18,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#ffd9a8",
      "emissiveIntensity": 3,
      "note": "A long mouth lamp east fixture"
    },
    {
      "kind": "box",
      "center": [
        14,
        0.4,
        13.4
      ],
      "halfExtents": [
        0.6,
        0.4,
        0.4
      ],
      "material": "wood",
      "hidden": true,
      "note": "prop collision"
    },
    {
      "kind": "box",
      "center": [
        25,
        3,
        24.4
      ],
      "halfExtents": [
        0.18,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#ffd9a8",
      "emissiveIntensity": 3,
      "note": "mid alley mouth lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        2,
        3,
        10.4
      ],
      "halfExtents": [
        0.18,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#ffd9a8",
      "emissiveIntensity": 3,
      "note": "mid alley plaza lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        24.5,
        1.75,
        31.75
      ],
      "halfExtents": [
        0.5,
        1.75,
        4.25
      ],
      "material": "plaster",
      "note": "T road baffle"
    },
    {
      "kind": "box",
      "center": [
        43.5,
        0.6,
        38.5
      ],
      "halfExtents": [
        0.6,
        0.6,
        0.6
      ],
      "material": "wood",
      "hidden": true,
      "note": "prop collision"
    },
    {
      "kind": "box",
      "center": [
        40,
        3,
        24.4
      ],
      "halfExtents": [
        0.18,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#ffd9a8",
      "emissiveIntensity": 3,
      "note": "banana mouth lamp south fixture"
    },
    {
      "kind": "box",
      "center": [
        22.4,
        3,
        26
      ],
      "halfExtents": [
        0.18,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#ffd9a8",
      "emissiveIntensity": 3,
      "note": "T road lane lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -28.5,
        1.75,
        -27.25
      ],
      "halfExtents": [
        0.5,
        1.75,
        3.25
      ],
      "material": "plaster",
      "note": "corridor baffle"
    },
    {
      "kind": "box",
      "center": [
        -28.5,
        0.5,
        -37.5
      ],
      "halfExtents": [
        0.8,
        0.5,
        0.8
      ],
      "material": "brick",
      "note": "CT well"
    },
    {
      "kind": "box",
      "center": [
        -37,
        3,
        -24.4
      ],
      "halfExtents": [
        0.18,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#ffd9a8",
      "emissiveIntensity": 3,
      "note": "graveyard mouth lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -21.5,
        3.6,
        -22.95
      ],
      "halfExtents": [
        0.04,
        0.04,
        0.55
      ],
      "material": "metal",
      "note": "altar lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -21.5,
        3.9,
        -6.64
      ],
      "halfExtents": [
        0.04,
        0.04,
        0.14
      ],
      "material": "metal",
      "note": "church door lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -29.39,
        2.9,
        -15.5
      ],
      "halfExtents": [
        0.11,
        0.04,
        0.04
      ],
      "material": "metal",
      "note": "church side door lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -2,
        3.775,
        -16
      ],
      "halfExtents": [
        0.04,
        0.225,
        0.04
      ],
      "material": "metal",
      "note": "library lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -2,
        2.7,
        -7.86
      ],
      "halfExtents": [
        0.04,
        0.04,
        0.14
      ],
      "material": "metal",
      "note": "library south door lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -2,
        2.7,
        -24.14
      ],
      "halfExtents": [
        0.04,
        0.04,
        0.14
      ],
      "material": "metal",
      "note": "library north door lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -8,
        3.125,
        -0.75
      ],
      "halfExtents": [
        0.04,
        0.075,
        0.04
      ],
      "material": "metal",
      "note": "arch lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        12,
        1.43,
        -27
      ],
      "halfExtents": [
        0.04,
        1.42,
        0.04
      ],
      "material": "metal",
      "note": "B gate lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        33.09,
        2.9,
        -18.5
      ],
      "halfExtents": [
        0.91,
        0.04,
        0.04
      ],
      "material": "metal",
      "note": "banana mouth lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        23,
        1.975,
        -30
      ],
      "halfExtents": [
        0.04,
        1.965,
        0.04
      ],
      "material": "metal",
      "note": "B site lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        37.41,
        2.9,
        0.4
      ],
      "halfExtents": [
        1.41,
        0.04,
        0.04
      ],
      "material": "metal",
      "note": "banana bend lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        3,
        1.825,
        4
      ],
      "halfExtents": [
        0.04,
        1.125,
        0.04
      ],
      "material": "metal",
      "note": "well lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        9.09,
        2.7,
        -7.6
      ],
      "halfExtents": [
        0.91,
        0.04,
        0.04
      ],
      "material": "metal",
      "note": "alley mouth lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -27.29,
        3,
        -27
      ],
      "halfExtents": [
        0.71,
        0.04,
        0.04
      ],
      "material": "metal",
      "note": "corridor mouth lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -6,
        3,
        -29.86
      ],
      "halfExtents": [
        0.04,
        0.04,
        0.14
      ],
      "material": "metal",
      "note": "corridor lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -26,
        2.225,
        2
      ],
      "halfExtents": [
        0.04,
        2.215,
        0.04
      ],
      "material": "metal",
      "note": "A site lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -35,
        2.4,
        13.86
      ],
      "halfExtents": [
        0.04,
        0.04,
        0.14
      ],
      "material": "metal",
      "note": "A long mouth lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -5,
        2.77,
        16
      ],
      "halfExtents": [
        0.04,
        0.13,
        0.04
      ],
      "material": "metal",
      "note": "apartments lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        0.11,
        2.7,
        12
      ],
      "halfExtents": [
        0.11,
        0.04,
        0.04
      ],
      "material": "metal",
      "note": "apartments east door lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        32,
        2.77,
        17
      ],
      "halfExtents": [
        0.04,
        0.13,
        0.04
      ],
      "material": "metal",
      "note": "banana house lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        27.6,
        2.825,
        15
      ],
      "halfExtents": [
        0.04,
        0.075,
        0.04
      ],
      "material": "metal",
      "note": "banana house west door lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        36.11,
        2.7,
        17
      ],
      "halfExtents": [
        0.11,
        0.04,
        0.04
      ],
      "material": "metal",
      "note": "banana house east door lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        23.29,
        3,
        31.5
      ],
      "halfExtents": [
        0.71,
        0.04,
        0.04
      ],
      "material": "metal",
      "note": "A long mouth lamp east fixture mount"
    },
    {
      "kind": "box",
      "center": [
        23.41,
        3,
        24.4
      ],
      "halfExtents": [
        1.41,
        0.04,
        0.04
      ],
      "material": "metal",
      "note": "mid alley mouth lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        0.91,
        3,
        10.4
      ],
      "halfExtents": [
        0.91,
        0.04,
        0.04
      ],
      "material": "metal",
      "note": "mid alley plaza lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        40,
        1.48,
        24.4
      ],
      "halfExtents": [
        0.04,
        1.47,
        0.04
      ],
      "material": "metal",
      "note": "banana mouth lamp south fixture mount"
    },
    {
      "kind": "box",
      "center": [
        22.11,
        3,
        26
      ],
      "halfExtents": [
        0.11,
        0.04,
        0.04
      ],
      "material": "metal",
      "note": "T road lane lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -37,
        1.48,
        -24.4
      ],
      "halfExtents": [
        0.04,
        1.47,
        0.04
      ],
      "material": "metal",
      "note": "graveyard mouth lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        31.5,
        0.595,
        -20.5
      ],
      "halfExtents": [
        1.58,
        0.595,
        0.39
      ],
      "material": "sand",
      "hidden": true,
      "note": "sandbag wall"
    },
    {
      "kind": "box",
      "center": [
        40,
        0.595,
        12
      ],
      "halfExtents": [
        1.58,
        0.595,
        0.39
      ],
      "material": "sand",
      "hidden": true,
      "note": "sandbag wall"
    },
    {
      "kind": "box",
      "center": [
        -42,
        0.595,
        1
      ],
      "halfExtents": [
        1.58,
        0.595,
        0.39
      ],
      "material": "sand",
      "hidden": true,
      "note": "sandbag wall"
    },
    {
      "kind": "box",
      "center": [
        -40,
        0.595,
        20
      ],
      "halfExtents": [
        1.58,
        0.595,
        0.39
      ],
      "material": "sand",
      "hidden": true,
      "note": "sandbag wall"
    },
    {
      "kind": "box",
      "center": [
        26,
        0.595,
        38.5
      ],
      "halfExtents": [
        1.58,
        0.595,
        0.39
      ],
      "material": "sand",
      "hidden": true,
      "note": "sandbag wall"
    },
    {
      "kind": "box",
      "center": [
        -27.5,
        0.595,
        -25.5
      ],
      "halfExtents": [
        1.58,
        0.595,
        0.39
      ],
      "material": "sand",
      "hidden": true,
      "note": "sandbag wall"
    }
  ],
  "spawns": [
    {
      "position": [
        31,
        0.05,
        37
      ],
      "yaw": 0.697,
      "team": 0
    },
    {
      "position": [
        -42,
        0.05,
        -37
      ],
      "yaw": 3.99,
      "team": 1
    },
    {
      "position": [
        35,
        0.05,
        37
      ],
      "yaw": 0.758,
      "team": 0
    },
    {
      "position": [
        -42,
        0.05,
        -34
      ],
      "yaw": 4.032,
      "team": 1
    },
    {
      "position": [
        39,
        0.05,
        37
      ],
      "yaw": 0.812,
      "team": 0
    },
    {
      "position": [
        -42,
        0.05,
        -30
      ],
      "yaw": 4.092,
      "team": 1
    },
    {
      "position": [
        43,
        0.05,
        37
      ],
      "yaw": 0.86,
      "team": 0
    },
    {
      "position": [
        -42,
        0.05,
        -27
      ],
      "yaw": 4.141,
      "team": 1
    },
    {
      "position": [
        33,
        0.05,
        33
      ],
      "yaw": 0.785,
      "team": 0
    },
    {
      "position": [
        -38,
        0.05,
        -37
      ],
      "yaw": 3.94,
      "team": 1
    },
    {
      "position": [
        37,
        0.05,
        33
      ],
      "yaw": 0.842,
      "team": 0
    },
    {
      "position": [
        -38,
        0.05,
        -34
      ],
      "yaw": 3.982,
      "team": 1
    },
    {
      "position": [
        41,
        0.05,
        33
      ],
      "yaw": 0.893,
      "team": 0
    },
    {
      "position": [
        -38,
        0.05,
        -30
      ],
      "yaw": 4.044,
      "team": 1
    },
    {
      "position": [
        39,
        0.05,
        29
      ],
      "yaw": 0.931,
      "team": 0
    },
    {
      "position": [
        -38,
        0.05,
        -27
      ],
      "yaw": 4.095,
      "team": 1
    }
  ],
  "props": [
    {
      "model": "/game/models/synty/props/crate-large-01.glb",
      "position": [
        28,
        0,
        -33
      ]
    },
    {
      "model": "/game/models/synty/props/crate-01.glb",
      "position": [
        29.4,
        0,
        -33.2
      ]
    },
    {
      "model": "/game/models/urban/pallet.glb",
      "position": [
        15.5,
        0,
        -35
      ]
    },
    {
      "model": "/game/models/synty/props/crate-01.glb",
      "position": [
        15.5,
        0.4,
        -35
      ]
    },
    {
      "model": "/game/models/synty/props/pallet-stack-01.glb",
      "position": [
        22,
        0,
        -22
      ]
    },
    {
      "model": "/game/models/synty/props/barrel-01.glb",
      "position": [
        27,
        0,
        -34.4
      ]
    },
    {
      "model": "/game/models/urban/sandbags.glb",
      "position": [
        31.5,
        0,
        -20.5
      ]
    },
    {
      "model": "/game/models/urban/sandbags.glb",
      "position": [
        40,
        0,
        12
      ]
    },
    {
      "model": "/game/models/synty/props/crate-large-01.glb",
      "position": [
        43.5,
        0,
        8
      ]
    },
    {
      "model": "/game/models/synty/props/crate-01.glb",
      "position": [
        31,
        0,
        -12
      ]
    },
    {
      "model": "/game/models/synty/props/barrel-02.glb",
      "position": [
        35,
        0,
        -13
      ]
    },
    {
      "model": "/game/models/synty/props/barrel-01.glb",
      "position": [
        43.6,
        0,
        -3
      ]
    },
    {
      "model": "/game/models/synty/props/crate-01.glb",
      "position": [
        -3,
        0,
        -5
      ]
    },
    {
      "model": "/game/models/synty/props/barrel-01.glb",
      "position": [
        -4.2,
        0,
        -5.4
      ]
    },
    {
      "model": "/game/models/synty/props/crate-01.glb",
      "position": [
        -8,
        0,
        -29.3
      ]
    },
    {
      "model": "/game/models/synty/props/barrel-01.glb",
      "position": [
        4,
        0,
        -29.3
      ]
    },
    {
      "model": "/game/models/synty/props/crate-large-01.glb",
      "position": [
        -16,
        0,
        8
      ]
    },
    {
      "model": "/game/models/synty/props/crate-01.glb",
      "position": [
        -17.4,
        0,
        8.4
      ]
    },
    {
      "model": "/game/models/urban/pallet.glb",
      "position": [
        -30,
        0,
        12
      ]
    },
    {
      "model": "/game/models/synty/props/barrel-01.glb",
      "position": [
        -15,
        0,
        9.6
      ]
    },
    {
      "model": "/game/models/urban/sandbags.glb",
      "position": [
        -42,
        0,
        1
      ]
    },
    {
      "model": "/game/models/synty/props/pallet-stack-01.glb",
      "position": [
        8,
        0,
        33.8
      ]
    },
    {
      "model": "/game/models/synty/props/crate-large-01.glb",
      "position": [
        -30,
        0,
        29
      ]
    },
    {
      "model": "/game/models/synty/props/barrel-02.glb",
      "position": [
        -28.6,
        0,
        29.4
      ]
    },
    {
      "model": "/game/models/urban/sandbags.glb",
      "position": [
        -40,
        0,
        20
      ]
    },
    {
      "model": "/game/models/synty/props/crate-01.glb",
      "position": [
        14,
        0,
        13.4
      ]
    },
    {
      "model": "/game/models/synty/props/barrel-01.glb",
      "position": [
        23,
        0,
        20
      ]
    },
    {
      "model": "/game/models/synty/props/crate-large-01.glb",
      "position": [
        43.5,
        0,
        38.5
      ]
    },
    {
      "model": "/game/models/urban/sandbags.glb",
      "position": [
        26,
        0,
        38.5
      ]
    },
    {
      "model": "/game/models/synty/props/barrel-01.glb",
      "position": [
        43.8,
        0,
        26
      ]
    },
    {
      "model": "/game/models/urban/sandbags.glb",
      "position": [
        -27.5,
        0,
        -25.5
      ]
    },
    {
      "model": "/game/models/synty/props/barrel-01.glb",
      "position": [
        -44,
        0,
        -39
      ]
    }
  ],
  "lights": [
    {
      "kind": "spot",
      "position": [
        -21.5,
        8.2,
        -15
      ],
      "color": "#fff1d6",
      "intensity": 320,
      "distance": 20,
      "target": [
        -21.5,
        0,
        -18
      ],
      "angle": 0.7,
      "penumbra": 0.4,
      "castShadow": true,
      "note": "church nave light"
    },
    {
      "kind": "point",
      "position": [
        -21.5,
        3.6,
        -22.2
      ],
      "color": "#ffd9a8",
      "intensity": 40,
      "distance": 9,
      "note": "altar lamp"
    },
    {
      "kind": "point",
      "position": [
        -21.5,
        3.9,
        -6.9
      ],
      "color": "#ffd9a8",
      "intensity": 28,
      "distance": 7,
      "note": "church door lamp"
    },
    {
      "kind": "point",
      "position": [
        -29.1,
        2.9,
        -15.5
      ],
      "color": "#ffd9a8",
      "intensity": 28,
      "distance": 7,
      "note": "church side door lamp"
    },
    {
      "kind": "point",
      "position": [
        -2,
        3.5,
        -16
      ],
      "color": "#ffe3b0",
      "intensity": 45,
      "distance": 10,
      "note": "library lamp"
    },
    {
      "kind": "point",
      "position": [
        -2,
        2.7,
        -7.6
      ],
      "color": "#ffd9a8",
      "intensity": 28,
      "distance": 7,
      "note": "library south door lamp"
    },
    {
      "kind": "point",
      "position": [
        -2,
        2.7,
        -24.4
      ],
      "color": "#ffd9a8",
      "intensity": 28,
      "distance": 7,
      "note": "library north door lamp"
    },
    {
      "kind": "point",
      "position": [
        -8,
        3,
        -0.75
      ],
      "color": "#ffd9a8",
      "intensity": 40,
      "distance": 9,
      "castShadow": true,
      "note": "arch lamp"
    },
    {
      "kind": "point",
      "position": [
        12,
        2.9,
        -27
      ],
      "color": "#ffd9a8",
      "intensity": 28,
      "distance": 7,
      "note": "B gate lamp"
    },
    {
      "kind": "point",
      "position": [
        32,
        2.9,
        -18.5
      ],
      "color": "#ffd9a8",
      "intensity": 28,
      "distance": 7,
      "note": "banana mouth lamp"
    },
    {
      "kind": "point",
      "position": [
        23,
        4,
        -30
      ],
      "color": "#fff1d6",
      "intensity": 60,
      "distance": 14,
      "castShadow": true,
      "note": "B site lamp"
    },
    {
      "kind": "point",
      "position": [
        39,
        2.9,
        0.4
      ],
      "color": "#ffd9a8",
      "intensity": 28,
      "distance": 7,
      "note": "banana bend lamp"
    },
    {
      "kind": "point",
      "position": [
        3,
        3,
        4
      ],
      "color": "#ffe3b0",
      "intensity": 30,
      "distance": 9,
      "note": "well lamp"
    },
    {
      "kind": "point",
      "position": [
        8,
        2.7,
        -7.6
      ],
      "color": "#ffd9a8",
      "intensity": 28,
      "distance": 7,
      "note": "alley mouth lamp"
    },
    {
      "kind": "point",
      "position": [
        -26.4,
        3,
        -27
      ],
      "color": "#ffd9a8",
      "intensity": 28,
      "distance": 7,
      "note": "corridor mouth lamp"
    },
    {
      "kind": "point",
      "position": [
        -6,
        3,
        -29.6
      ],
      "color": "#ffd9a8",
      "intensity": 28,
      "distance": 7,
      "note": "corridor lamp"
    },
    {
      "kind": "point",
      "position": [
        -26,
        4.5,
        2
      ],
      "color": "#fff1d6",
      "intensity": 50,
      "distance": 14,
      "note": "A site lamp"
    },
    {
      "kind": "point",
      "position": [
        -35,
        2.4,
        13.6
      ],
      "color": "#ffd9a8",
      "intensity": 28,
      "distance": 7,
      "note": "A long mouth lamp"
    },
    {
      "kind": "point",
      "position": [
        -5,
        2.6,
        16
      ],
      "color": "#ffe3b0",
      "intensity": 40,
      "distance": 9,
      "note": "apartments lamp"
    },
    {
      "kind": "point",
      "position": [
        -6,
        2.7,
        9.6
      ],
      "color": "#ffd9a8",
      "intensity": 28,
      "distance": 7,
      "note": "apartments north door lamp"
    },
    {
      "kind": "point",
      "position": [
        0.4,
        2.7,
        12
      ],
      "color": "#ffd9a8",
      "intensity": 28,
      "distance": 7,
      "note": "apartments east door lamp"
    },
    {
      "kind": "point",
      "position": [
        32,
        2.6,
        17
      ],
      "color": "#ffe3b0",
      "intensity": 40,
      "distance": 9,
      "note": "banana house lamp"
    },
    {
      "kind": "point",
      "position": [
        27.6,
        2.7,
        15
      ],
      "color": "#ffd9a8",
      "intensity": 28,
      "distance": 7,
      "note": "banana house west door lamp"
    },
    {
      "kind": "point",
      "position": [
        36.4,
        2.7,
        17
      ],
      "color": "#ffd9a8",
      "intensity": 28,
      "distance": 7,
      "note": "banana house east door lamp"
    },
    {
      "kind": "point",
      "position": [
        22.4,
        3,
        31.5
      ],
      "color": "#ffd9a8",
      "intensity": 28,
      "distance": 7,
      "note": "A long mouth lamp east"
    },
    {
      "kind": "point",
      "position": [
        25,
        3,
        24.4
      ],
      "color": "#ffd9a8",
      "intensity": 28,
      "distance": 7,
      "note": "mid alley mouth lamp"
    },
    {
      "kind": "point",
      "position": [
        2,
        3,
        10.4
      ],
      "color": "#ffd9a8",
      "intensity": 28,
      "distance": 7,
      "note": "mid alley plaza lamp"
    },
    {
      "kind": "spot",
      "position": [
        44,
        5.8,
        39
      ],
      "color": "#fff3e0",
      "intensity": 260,
      "distance": 30,
      "target": [
        33,
        0,
        30
      ],
      "angle": 0.65,
      "penumbra": 0.4,
      "note": "T road flood"
    },
    {
      "kind": "spot",
      "position": [
        23,
        5.8,
        39
      ],
      "color": "#fff3e0",
      "intensity": 200,
      "distance": 28,
      "target": [
        34,
        0,
        30
      ],
      "angle": 0.65,
      "penumbra": 0.4,
      "note": "T road flood west"
    },
    {
      "kind": "point",
      "position": [
        40,
        3,
        24.4
      ],
      "color": "#ffd9a8",
      "intensity": 28,
      "distance": 7,
      "note": "banana mouth lamp south"
    },
    {
      "kind": "point",
      "position": [
        22.4,
        3,
        26
      ],
      "color": "#ffd9a8",
      "intensity": 28,
      "distance": 7,
      "note": "T road lane lamp"
    },
    {
      "kind": "spot",
      "position": [
        -44,
        5.8,
        -39
      ],
      "color": "#fff3e0",
      "intensity": 260,
      "distance": 30,
      "target": [
        -34,
        0,
        -31
      ],
      "angle": 0.65,
      "penumbra": 0.4,
      "note": "CT yard flood"
    },
    {
      "kind": "spot",
      "position": [
        -27,
        5.8,
        -39
      ],
      "color": "#fff3e0",
      "intensity": 200,
      "distance": 28,
      "target": [
        -36,
        0,
        -30
      ],
      "angle": 0.65,
      "penumbra": 0.4,
      "note": "CT yard flood east"
    },
    {
      "kind": "point",
      "position": [
        -37,
        3,
        -24.4
      ],
      "color": "#ffd9a8",
      "intensity": 28,
      "distance": 7,
      "note": "graveyard mouth lamp"
    }
  ],
  "sites": [
    {
      "id": "A",
      "center": [
        -26,
        0,
        5
      ],
      "halfExtents": [
        6,
        2,
        6
      ]
    },
    {
      "id": "B",
      "center": [
        23,
        0,
        -31
      ],
      "halfExtents": [
        6,
        2,
        6
      ]
    }
  ]
}
